import React from 'react';
import { useT } from '@transifex/react';
import { HeroBrandEvolution } from '../../../HeroBrandEvolution';
import messages from '../../messages';

const BanksHero = () => {
  const t = useT();

  return (
    <HeroBrandEvolution
      heading={t(messages.banksHeroHeading)}
      body_text={t(messages.banksHeroDescription)}
      cta_button={{
        button_text: '',
        button_link: undefined,
        onTrackCtaClicked: function (): void {
          throw new Error('Function not implemented.');
        },
        open_link_in_a_new_tab: undefined,
      }}
      side_image={{
        uid: 'bank_list_page_hero_brand_evolution_side_image_uid',
        url: '/cp_assets/bank-list-page-hero-side-image.png',
        title: t(messages.banksHeroHeading),
        content_type: 'image/png',
      }}
    />
  );
};

export default BanksHero;
